import {useState} from 'react';
import {isValidEmail, MAX_EMAIL_LENGTH} from '../validation';

export default function ForgotPasswordScreen() {
    const [email, setEmail] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState('');
    const [submitting, setSubmitting] = useState(false);

    async function handleSubmit(e) {
        e.preventDefault();
        setError('');
        if (!isValidEmail(email)) {
            setError('Please enter a valid email address.');
            return;
        }
        setSubmitting(true);
        try {
            await fetch('/api/v1/auth/forgot-password', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({email}),
            });
            setSubmitted(true);
        } catch {
            setError('Network error. Please try again.');
        } finally {
            setSubmitting(false);
        }
    }

    return (
        <div className="login-screen">
            <form className="login-form" onSubmit={handleSubmit}>
                <h2 className="login-title">Forgot password</h2>
                {error && <p className="login-error">{error}</p>}
                {submitted ? (
                    <p className="login-success">
                        If that email is registered, a reset link has been sent.
                    </p>
                ) : (
                    <>
                        <input
                            className="login-input"
                            type="email"
                            placeholder="Email"
                            value={email}
                            maxLength={MAX_EMAIL_LENGTH}
                            onChange={e => setEmail(e.target.value)}
                            autoFocus
                        />
                        <button
                            className="login-button"
                            type="submit"
                            disabled={!email || submitting}
                        >{submitting ? 'Sending...' : 'Send reset link'}</button>
                    </>
                )}
                <p className="login-register-link">
                    <a href="/?signin">Back to sign in</a>
                </p>
            </form>
        </div>
    );
}
